import React from "react";

import SuperadminHeader from "../components/heading/SuperadminHeader";

const SuperAdminLayout = ({ children }) => {
  return (
    <div className="flex min-h-screen flex-col">
      <SuperadminHeader />
      <main className="container mx-auto flex-grow px-4 sm:px-8">{children}</main>
      <footer>
        <p>© {new Date().getFullYear()} Admin Portal. All Rights Reserved.</p>
      </footer>
    </div>
  );
};

export default SuperAdminLayout;
